<template>
	<div>
		<div class="image-swap">
			<img class="before-image" :src="$store.state.user.user.photoURL" />
			<ion-icon name="arrow-round-forward"></ion-icon>
			<file-pond
				name="imageDrop"
				ref="pond"
				label-idle="Drop image here"
				allow-file-type-validation="true"
				allow-multiple="false"
				instantUpload="false"
				accepted-file-types="image/png, image/jpeg, image/gif, image/jpg"
				allowImagePreview="true"
				allowImageCrop="true"
				allowImageEdit="true"
				allowImageResize="true"
				allowImageTransform="true"
				allowReplace="true"
				allowImageExifOrientation="true"
				checkValidity="true"
				maxFiles="1"
				imagePreviewHeight="100"
				imagePreviewWidth="100"
				imageCropAspectRatio="1:1"
				imageResizeTargetWidth="200"
				imageResizeTargetHeight="200"
				stylePanelLayout="compact circle"
				styleLoadIndicatorPosition="center bottom"
				styleProgressIndicatorPosition="center bottom"
				styleButtonProcessItemPosition="center bottom"
				styleButtonRemoveItemPosition="center bottom"
				@init="handleFilePondInit"
				@addfile="handleFileProcess"
				@removefile="handleFileRemove"
			></file-pond>
		</div>
		<br />
		<div class="submit">
			<button
				type="button"
				:disabled="imageFile === null"
				class="update-button stackng-button button"
				@click.prevent="uploadPhotoToStorage"
			>Update Image</button>
		</div>
	</div>
</template>

<script>
import firebase from "firebase/app";
import { db, storage } from "../../../resources/firebase";
// import { imageEventBus } from './userInfo/UserInfo.vue'
import vueFilePond from "vue-filepond";

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
// import FilePondPluginFileEncode from 'filepond-plugin-file-encode'
import FilePondPluginImageEdit from "filepond-plugin-image-edit";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImageCrop from "filepond-plugin-image-crop";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";

// import 'filepond/dist/filepond.min.css'
// import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

//Create Component
const FilePond = vueFilePond(
	FilePondPluginFileValidateType,
	FilePondPluginFileValidateSize,
	FilePondPluginImagePreview,
	// FilePondPluginFileEncode,
	FilePondPluginImageExifOrientation,
	FilePondPluginImageCrop,
	FilePondPluginImageEdit,
	FilePondPluginImageResize,
	FilePondPluginImageTransform
);

export default {
	data() {
		return {
			emitMessage: {
				message: ""
			},
			imageFile: null
		};
	},
	components: {
		FilePond
	},
	methods: {
		handleFilePondInit() {
			// console.log('File Pond initialized')
			// this.$refs.pond.addFile(this.imageFile);
		},
		handleFileProcess(err, file) {
			const _this = this;

			if (err) {
				console.log(err);
				this.emitMessage.message = err.main;

				_this.$toasted.show(`Error - ${err.main}`, {
					theme: "bubble",
					position: "bottom-center",
					duration: 1500
				});
			} else {
				this.imageFile = file.file;
			}
		},
		handleFileRemove() {
			this.imageFile = null;
		},
		uploadPhotoToStorage() {
			var storageRef = storage.ref();
			var userRef = storageRef.child(this.$store.state.user.authUser.uid);
			var userImageRef = userRef.child(`images/${this.imageFile.name}`);
			const updateButton = document.querySelector(".update-button");
			updateButton.classList.add("is-loading");
			var uploadTask = userRef.put(this.imageFile);
			const _this = this;

			uploadTask.on(
				"state_changed",
				snapshot => {
					var progress =
						(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					// console.log('Upload is ' + progress + '% done');

					switch (snapshot.state) {
						case firebase.storage.TaskState.PAUSED: // or 'paused'
							// console.log('Upload is paused');
							break;
						case firebase.storage.TaskState.RUNNING: // or 'running'
							// console.log('Upload is running');
							break;
					}
				},
				function(error) {
					console.log(error);

					_this.$toasted.show(
						"Error",
						{
							theme: "bubble",
							position: "bottom-center",
							duration: 1500
						},
						updateButton.classList.remove("is-loading")
					);
				},
				function() {
					// Handle successful uploads on complete
					uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
						//Update user photoURL state
						_this.$store.dispatch("setUserInfo", { photoURL: downloadURL });
						_this.$store.state.user.user.photoFile = _this.imageFile;

						//Update user's photoURL in firestore
						db.collection("users")
							.where("userID", "==", _this.$store.state.user.authUser.uid)
							.get()
							.then(snapshot => {
								const userDoc = snapshot.docs[0].id;

								db.collection("users")
									.doc(userDoc)
									.update({
										photoURL: downloadURL
									});
								let message = "success";

								// imageEventBus.$emit('handleUpload', message)

								//Show toast
								_this.$toasted.show(
									"Image updated",
									{
										theme: "bubble",
										position: "bottom-center",
										duration: 1500
									},
									updateButton.classList.remove("is-loading")
								);

								_this.closeModal();
							});
					});
				}
			);
		},
		closeModal() {
			const html = document.querySelector("html");
			const modalContainer = document.querySelector(".modal-container");
			const app = document.querySelector("#app");
			app.classList.remove("blur-app");
			modalContainer.removeEventListener("click", this.closeModal);
			html.style.overflowY = "scroll";

			this.$store.commit("updateImageUploadModal", { show: false });
		}
	}
};
</script>

<style scoped>
.image-swap {
	display: flex;
	align-items: center;
	justify-content: center;
}

.before-image {
	max-width: 150px;
	height: 100px;
	width: 100px;
	margin-right: 10px;
	border-radius: 50%;
	object-fit: cover;
}

ion-icon {
	margin-right: 10px;
	font-size: 20px;
	color: #b7b7b7;
}

button {
	margin-right: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/users/profile/ImageUpload.vue